import { ThumborLoader } from '../../util/thumborLoader'
import { IconSafeBuy } from '@gazin/ecommerce-ui'
import Image from 'next/image'
import { usePaymentMethodsIcons } from 'src/util/hooks/usePaymentMethodsIcons'

export default function areaSecundaria() {
  const paymentMethodsIcons = usePaymentMethodsIcons()

  const reclameAquiBadge =
    process.env.NODE_ENV === 'production'
      ? 'https://gazin-marketplace.s3.amazonaws.com/midias/imagens/reclame_aqui.png.png'
      : 'https://gazin-marketplace-teste.s3.amazonaws.com/midias/imagens/reclame_aqui.png.png'
  return (
    <div className="area-secundaria">
      <div className="cont-geral">
        <div className="esq">
          <div className="item">
            <div className="formasDePagamento">
              <span>Formas de pagamento</span>
              <ul>{paymentMethodsIcons}</ul>
            </div>
          </div>
          <div className="item">
            <ul className="selos">
              <li key="safe-buy">
                <IconSafeBuy />
              </li>
              <li key="reclame-aqui">
                <Image
                  src={ThumborLoader({
                    src: reclameAquiBadge,
                    width: 140,
                    quality: 90,
                  })}
                  alt="Reclame Aqui"
                  width={140}
                  height={70}
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
      <p className="texto-rodape">
        Preços e condições de pagamento exclusivos para compras via Internet.
        Vendas sujeitas à analise e confirmação de dados. Fica garantida a
        empresa a eventual retificação das ofertas e erros de digitação que
        possam ter sido veiculados, podendo ser estornado o valor da compra.
        <br />
        Gazin Indústria e Comércio De Móveis e Eletrodomésticos LTDA - CNPJ:
        77.941.490/0294-80
        <br />
        Endereço: ROD PR 082 SN - Centro - Douradina-PR - CEP: 87485-000
      </p>
    </div>
  )
}
